<template>
  <div class="ps-history">
    <table class="table ps-history-table">
      <thead>
      <tr>
        <th scope="col">کاربر</th>
        <th scope="col">زمان</th>
        <th scope="col">#</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="history in histories" :key="history.id">
        <history-item :history="history"/>
      </template>
      </tbody>
    </table>

    <m-paginate1 :meta="pagination" :on-change-page="changePage"/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import HistoryItem from "@/components/ProjectHistory/HistoryItem";
import mPaginate1 from '@moeinmdn/miw-alpha-components/src/package/Pagination/Paginate1'

export default {
  name: "ProjectHistoryManager",
  components: {HistoryItem, mPaginate1},
  computed: {
    ...mapGetters({
      histories: "ProjectHistory/getHistories",
      pagination: "ProjectHistory/getPagination"
    })
  },
  methods: {
    async changePage(page) {
      this.$store.dispatch('ProjectHistory/setHistories', page);
    },
  }
}
</script>

<style scoped>
.ps-history {
  background: #2c2c2c !important;
  color: #ddd !important;
  border-radius: 8px;
  padding: 8px;
  min-height: 100%;
}

.ps-history-table {
  background: #2c2c2c !important;
  color: #ddd !important;
  margin-bottom: 0;
}

.ps-history-table :deep(th),
.ps-history-table :deep(td),
.ps-history :deep(th),
.ps-history :deep(td) {
  background: #2c2c2c !important;
  color: #ddd !important;
  border-color: #444 !important;
}

.ps-history :deep(.history-item),
.ps-history :deep(tr) {
  background: #2c2c2c !important;
  color: #ddd !important;
}

.ps-history :deep(a),
.ps-history :deep(.bi) {
  color: #ccc !important;
}
</style>
